import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
var _excluded = ["trigger", "ariaLabel", "id", "title", "children", "className", "onClose", "handleAction", "primaryButton", "secondaryButton", "validate"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.object.assign.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2017,2020. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Dialog from './Dialog';
import Button from './Button';
import { uniqueIdForComponent } from '../util';
var DialogTrigger = function DialogTrigger(_ref) {
  var trigger = _ref.trigger,
    ariaLabel = _ref.ariaLabel,
    id = _ref.id,
    title = _ref.title,
    children = _ref.children,
    className = _ref.className,
    onClose = _ref.onClose,
    handleAction = _ref.handleAction,
    primaryButton = _ref.primaryButton,
    secondaryButton = _ref.secondaryButton,
    validate = _ref.validate,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  /* dialogId should be a variable after we decouple the core.
   Having this as a state is a temporary workaround to not change the initial dialogId
   that was passed to the core init function everytime this component gets rerendered. */
  var _useState = useState(id || uniqueIdForComponent()),
    _useState2 = _slicedToArray(_useState, 1),
    dialogId = _useState2[0];
  var dialogProps = {
    ariaLabel: ariaLabel,
    title: title,
    children: children,
    onClose: onClose,
    open: false,
    onActionButtonClick: handleAction,
    validate: validate,
    primaryButton: primaryButton,
    secondaryButton: secondaryButton
  };
  var allProps = Object.assign(dialogProps, otherProps);
  var triggerButtonWithProps = trigger && /*#__PURE__*/React.cloneElement(trigger, {
    key: "dialog-trigger-button-".concat(dialogId),
    'data-modal-target': dialogId,
    className: className
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, triggerButtonWithProps, /*#__PURE__*/React.createElement(Dialog, _extends({
    open: false,
    key: "dialog-trigger-dialog-".concat(dialogId),
    id: dialogId
  }, allProps), children));
};
DialogTrigger.propTypes = {
  /** Dialog id */
  id: PropTypes.string,
  /** element that triggers the Dialog display */
  trigger: PropTypes.node.isRequired,
  /** dialog description for screen readers */
  ariaLabel: PropTypes.string.isRequired,
  /** dialog title */
  title: PropTypes.string,
  /** dialog contents */
  children: PropTypes.node,
  /** Additional styling */
  className: PropTypes.string,
  /** callback triggered when the primary button is clicked */
  handleAction: PropTypes.func,
  /**  function to validate form data in the dialog */
  validate: PropTypes.func,
  /**  function to call when the dialog is closed */
  onClose: PropTypes.func,
  /** indicates the button which should trigger the primary action */
  primaryButton: PropTypes.shape({
    type: PropTypes.oneOf([Button])
  }),
  /** indicates the button which should trigger the secondary action */
  secondaryButton: PropTypes.shape({
    type: PropTypes.oneOf([Button])
  })
};
DialogTrigger.defaultProps = {
  id: undefined,
  title: undefined,
  children: undefined,
  className: undefined,
  handleAction: function handleAction() {},
  onClose: function onClose() {},
  validate: undefined,
  secondaryButton: undefined,
  primaryButton: undefined
};
DialogTrigger.displayName = 'DialogTrigger';
export default DialogTrigger;